<div class="group-title">
  <span class="group-title-label">{{ title() }}</span>
  <div class="group-title-divider"></div>
</div>
